module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"desc":"Enter your investor number to check if you have any DFM PJSC unclaimed dividends.","formlabel":{"captcha":"captcha","nin":"NIN","securitycode":"Security Code"}}}')
  delete Component.options._Ctor
}
